const T = require("react").PropTypes;
const UUID = require("node-uuid");

const MaxFileSizeBytes = require("../Config.js").MaxFileSizeBytes;

const File = {
    Type: T.shape({
        IsInvalid: T.bool,
        IsUploading: T.bool,
        Message: T.string,
        UploadError: T.object,
        UploadStartedAt: T.object,
        BaseFile: T.shape({
            lastModified: T.number,
            lastModifiedDate: T.object,
            name: T.string,
            size: T.number, // bytes
            type: T.string
        })
    }),
    FromUpload(baseFile, validExtensions) {
        const uid = UUID.v1();

        let message = "";

        const nameSegments = baseFile.name.split(".");
        const extension = nameSegments[nameSegments.length - 1];

        if (baseFile.size > MaxFileSizeBytes) {
            message = "Too large";
        }

        if (validExtensions
            .map(e => e.toUpperCase())
            .indexOf(extension.toUpperCase()) === -1) {
            message = "Invalid type";
        }

        const result = {
            UID: uid,
            IsInvalid: message.length > 0,
            IsUploading: false,
            Message: message,
            UploadError: undefined,
            UploadStartedAt: null,
            BaseFile: baseFile
        };

        return result;
    }
};

module.exports = File;


// WEBPACK FOOTER //
// ./src/types/File.js